var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticStyle:{"width":"100%"},attrs:{"id":"editorElem-resource"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }